import { ValidationError } from "../types/ValidationError";

export abstract class ApiService {
    async handleResponse(response: Response) {
        if (response.ok) {
            return response;
        } else {
            switch (response.status) {
                case 400:
                    const error = await response.json();
                    if (error.invalidArguments) {
                        throw new ValidationError(error.invalidArguments);
                    }
                    throw new Error("400");
                default:
                    throw new Error(response.status.toString());
            }
        }
    }
}
